<input #fileInput (change)="fileChangeEvent($event)" type="file" name="pic" accept="image/*">
